// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2025project/q4/2025conveys/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};
const getList = (params: any) => {
  console.log(params);
  return http.get(`${urlPrefix}vote-list`, { params });
};
const getDetail = (params: any) => {
  return http.get(`${urlPrefix}detail`, { params });
};
const getRules = () => {
  return http.get(`${urlPrefix}rules`);
};
const getNews = (page: any, category: any, classId: any) => {
  return http.get(
    `/v1/news/topicList?page=${page}&classId=${classId}&category=${category}`,
  );
};
export { getBaseInfo, getList, getDetail, getRules, getNews };
